import React from 'react';
import { noop } from 'lodash';
import { Button } from 'antd';
import { ScheduleTwoTone } from '@ant-design/icons';

import { toCurrency } from 'utils/utils';
import { PropDecisionResponse } from 'services/proposal';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import TabDecisionDetails from './decisionsDetails';
import ModalControllerNV from 'components/ModalControllerNV';

type DecisionsTableProps = {
  decisions?: PropDecisionResponse[];
  onOpenDecisionDetail?: (id: number) => void;
};

const DecisionsTable = (props: DecisionsTableProps) => {
  const { decisions, onOpenDecisionDetail = noop } = props;

  const columns: DataGridColDef<PropDecisionResponse>[] = [
    {
      dataIndex: 'deccodelabel',
      width: '300px',
      fixed: 'left',
      render: (deccodelabel, record) => (
        <div>
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a
                onClick={() => {
                  setVisible(true);
                }}
              >
                {record.deccodelabel}
              </a>
            )}
            modal={({ setVisible, visible }) => (
              <TabDecisionDetails
                data={record}
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
              />
            )}
          />
        </div>
      ),
    },
    {
      dataIndex: 'dectype',
      width: '50px',
      align: 'left',
    },
    {
      dataIndex: 'declevellabel',
      width: '250px',
      align: 'left',
    },
    {
      dataIndex: 'finamountapproved',
      width: '150px',
      align: 'left',
      render: (val, record) => toCurrency(val),
    },
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (text, record) => (
        <Button
          icon={<ScheduleTwoTone twoToneColor="#eb2f96" />}
          onClick={(e) => {
            e.stopPropagation();
            onOpenDecisionDetail(record.decisionid);
          }}
        />
      ),
      fixed: 'right',
      width: '80px',
    },
  ];

  return (
    <DataGrid
      columns={columns}
      titleComcode="DecisionsList"
      dataSource={decisions}
      rowKey={(decision) => decision.decisionid}
    />
  );
};

export default DecisionsTable;
